import "core-js/modules/es6.string.small";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
export default {
  name: 'RichContentMediaText',
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload: function currentPayload() {
      var _ref, _ref2, _ref3, _ref4, _ref5;

      return {
        title: (_ref5 = this.payload) != null ? _ref5.title : _ref5,
        image: {
          small: formatPrismicImage((_ref4 = this.payload) != null ? (_ref4 = _ref4.image) != null ? _ref4.small : _ref4 : _ref4, ['q_auto,f_auto', 'w_200']) || EMPTY_PIXEL,
          large: formatPrismicImage((_ref3 = this.payload) != null ? (_ref3 = _ref3.image) != null ? _ref3.large : _ref3 : _ref3, ['q_auto,f_auto', 'w_500']) || EMPTY_PIXEL,
          alt: (_ref2 = this.payload) != null ? (_ref2 = _ref2.image) != null ? _ref2.alt : _ref2 : _ref2
        },
        description: (_ref = this.payload) != null ? _ref.description : _ref
      };
    }
  }
};